import Vue from 'vue';
import dayjs from 'dayjs';
export default Vue.extend({
    props: {
        tableData: { type: (Array), required: true },
    },
    methods: {
        prettyCreated(dateStr) {
            return dayjs(dateStr).fromNow();
        }
    },
});
